import React, { useEffect, useState } from "react";
import { useLang } from "../../context/LangContext";
import api, { formatApiError } from "../../lib/api";
import { toast } from "sonner";
import { CheckCircle2, XCircle } from "lucide-react";

function typeLabel(t, type) {
  const label = t(`type_${type}`);
  // If translation missing (returned the key), fall back to the raw type value
  return label === `type_${type}` ? type : label;
}

export default function AdminApprovals() {
  const { t } = useLang();
  const [pending, setPending] = useState([]);

  const load = async () => {
    try {
      const { data } = await api.get("/admin/properties/pending");
      setPending(data);
    } catch (e) { toast.error(formatApiError(e)); }
  };
  useEffect(() => { load(); }, []);

  const approve = async (id) => {
    try {
      await api.post(`/admin/properties/${id}/approve`);
      toast.success(t("saved"));
      load();
    } catch (e) { toast.error(formatApiError(e)); }
  };
  const reject = async (id) => {
    try {
      await api.post(`/admin/properties/${id}/reject`);
      toast.success(t("deleted"));
      load();
    } catch (e) { toast.error(formatApiError(e)); }
  };

  return (
    <div className="space-y-4" data-testid="admin-approvals-page">
      <h1 className="text-2xl sm:text-3xl font-semibold">{t("approvals")}</h1>
      {pending.length === 0 && (
        <div className="bg-white border border-[#E5E1D8] rounded-2xl p-8 text-center text-[#5C6053] text-sm">—</div>
      )}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {pending.map((p) => (
          <div key={p.id} data-testid={`pending-card-${p.id}`} className="bg-white border border-[#E5E1D8] rounded-2xl p-5 shadow-sm">
            <div className="flex justify-between items-start gap-3">
              <div>
                <h3 className="font-semibold">{p.name}</h3>
                <div className="text-xs text-[#5C6053] mt-1">{typeLabel(t, p.type)}</div>
                <div className="text-xs text-[#5C6053]">{p.governorate} — {p.wilayat}</div>
              </div>
              <div className="text-xs text-end">
                <div className="font-medium">{p.owner_name}</div>
                <div className="text-[#5C6053]" dir="ltr">{p.owner_phone}</div>
              </div>
            </div>
            <div className="mt-4 flex gap-2 justify-end">
              <button data-testid={`reject-${p.id}`} onClick={() => reject(p.id)} className="px-3 py-1.5 text-xs rounded-lg border border-[#C96A52] text-[#C96A52] inline-flex items-center gap-1">
                <XCircle size={14} /> {t("reject")}
              </button>
              <button data-testid={`approve-${p.id}`} onClick={() => approve(p.id)} className="px-3 py-1.5 text-xs rounded-lg brand-btn inline-flex items-center gap-1">
                <CheckCircle2 size={14} /> {t("approve")}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
